<div class="dtf-accountdetails">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


  <div *ngIf="(this.bodyLoaded)" class="mbfs-payoff-quote-spinner">

    <!--Default page to load while waiting for Redirection to Classic-->
    <section class="mbfs-home-hero"
      style="background-image: url(/static/assets/img/dtf-assets/images/redesign/mbfs_top_image_and_tint.jpg);">
      <section class="mbfs-home-hero__header">
        <h2 class="mbfs-home-hero__header-subtitle">
          {{ 'LoaderPages.BannerHeader' | translate }}
        </h2>
        <p class="mbfs-home-hero__header-text-demi">
          {{ 'LoaderPages.Loading' | translate }}
        </p>

        <!--Spinner-->
        <div class="mbfs-loading-spinner-overlay"></div>
        <div class="mbfs-loading-spinner"> </div>
      </section>
    </section>
  </div>

   <div class="container_dashboard" *ngIf="!this.bodyLoaded && !isCanadaPortal">
  
    <h4 class="dtfbrochures__header_dark">{{ 'Dashboard.ProfileHeader' | translate }}</h4>
   
      <div class="dtfbrochures__containerlong" *ngIf="!isTerminatedAccounts">
          <div class="row4">
            <div class="dynamicflexbox">
              <section class="section">
                <div class="section__item section__item--start">
                  <h4 class="dtfbrochures__header5">{{ 'Dashboard.NumAccounts' | translate }}</h4>
                  <h3 class="dtfbrochures__header6">{{this.recAccCount}}</h3>
                </div>
                <div class="section__item section__item--end">
                  <h4 class="dtfbrochures__header5">{{ 'Dashboard.CurrentDue' | translate }}</h4>
                  <h3 class="dtfbrochures__header6">${{this.totalDue}}</h3>
                </div>
              </section>
            </div>
          </div>
        </div>
    </div>
 
  
  <!--CA-->
  <div class="container_dashboard" *ngIf="!this.bodyLoaded && isCanadaPortal">
    <h4 class="dtfbrochures__header_dark">{{ 'Dashboard.ProfileHeader' | translate }}</h4>
    
      <div class="dtfbrochures__containerlong" *ngIf="!isTerminatedAccounts">
          <div class="row4">
            <div class="dynamicflexbox">
              <section class="section">
                <div class="section__item section__item--start">
                  <h4 class="dtfbrochures__header5">{{ 'Dashboard.NumAccounts' | translate }}</h4>
                  <h3 class="dtfbrochures__header6">{{this.recAccCount}}</h3>
                </div>
                <div class="section__item section__item--end">
                  <h4 class="dtfbrochures__header5">{{ 'Dashboard.CurrentDue' | translate }}</h4>
                  <h3 class="dtfbrochures__header6">${{this.totalDue}}</h3>
                </div>
              </section>
            </div>
          </div>
        </div>
    </div>

    <div class="container_dashboard">
      <div class="cardlike" *ngIf="!this.bodyLoaded && !isCanadaPortal">
        <p>{{ 'Dashboard.link' | translate }}</p>
        <br>
      </div>
    
      <div class="cardlike" *ngIf="!this.bodyLoaded && isCanadaPortal">
        <p>{{ 'Dashboard.link' | translate }}</p>
        <br>
      </div>
    </div>

    <a id="mbfs-header-login-cta" id="auto_triggeraddress" class="mbfs-header-login-cta-a" href="javascript:void(0)"
    (click)="onClickPassword($event)" hidden></a>
  
  <div class="container_dashboard">
    <div class="dtf-dashboard" style="padding-top: 41px; padding-bottom: 21px;">

      <div class="example-button-row" *ngIf="!this.bodyLoaded && !isCanadaPortal">
        <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedState" (change)="onChangeButton($event)">
          <mat-button-toggle  [value]="toggleEnum.Option1">{{ 'AccountDetails.Email' | translate }}</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option2">{{ 'AccountDetails.ChangePassword' | translate }}</mat-button-toggle>
          <mat-button-toggle *ngIf="!isTerminatedAccounts"  [value]="toggleEnum.Option3">{{ 'AccountDetails.Autopay' | translate }}</mat-button-toggle>
          <mat-button-toggle *ngIf="!isTerminatedAccounts" [value]="toggleEnum.Option4" (click)="fetchEbillFlagForUser()">{{ 'Dashboard.EbillButton' | translate }}</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option5">{{ 'AccountDetails.ChangeAddress' | translate }}</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div class="example-button-row" *ngIf="!this.bodyLoaded && isCanadaPortal">
        <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedState" (change)="onChangeButton($event)">
          <mat-button-toggle  [value]="toggleEnum.Option1">{{ 'AccountDetails.Email' | translate }}</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option2">{{ 'AccountDetails.ChangePassword' | translate }}</mat-button-toggle>
          <mat-button-toggle  *ngIf="!isTerminatedAccounts" [value]="toggleEnum.Option4" (click)="fetchEbillFlagForUser()">{{ 'Dashboard.EbillButton' | translate }}</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option5">{{ 'AccountDetails.ChangeAddress' | translate }}</mat-button-toggle>
          <!-- <mat-button-toggle [value]="toggleEnum.Option3" (click)="checkUrl('autopay')">{{ 'AccountDetails.Autopay' |
            translate }}</mat-button-toggle> -->
          <!-- <mat-button-toggle [value]="toggleEnum.Option4">{{
            'AccountDetails.eBill' | translate }}</mat-button-toggle>
        </mat-button-toggle-group> -->
      </mat-button-toggle-group>

</div>

      <div class="container_dashboard">
        <div class="mbfs-contact-us-page-inner" style="background-color: #e6e6e6;">
          <div *ngIf="SelectEmail && !contentChanged">
            <form [formGroup]="passwordForm" (ngSubmit)="updateAndSaveCurrentPassword($event)">
              <div class="row">
                <div class="tile left-tile">
                  <h1 class="header"> {{ 'LoginModal.ContactEmailHeader' | translate }}</h1>
                  <p>{{ 'LoginModal.ContactEmailDescription' | translate }}</p>     <p class="email-address override-align">{{ 'DocumentCenter.EmailAddress' | translate }}</p>
                  <mat-form-field class="example-full-width" appearance="outline" style="width: 100%;">
                    <mat-label>Email</mat-label>
                    <input matInput  value=" {{this.currentemailAddress}}">
                  </mat-form-field>
                  <button class="change-button" (click)="showPassConfirmation()" style="background-color: #00566A; width: 200px;">{{ 'LoginModal.ChangeEmailButton' | translate }}</button>
                </div>
                <div class="tile right-tile">
                  <h1 class="header">{{ 'LoginModal.PromotionalInfoHeader' | translate }}</h1>
                  <img src="/static/assets/img/dtf-assets/images/redesign/Promotional_infoPic.png" alt="Promotional Image" class="promotional-image">
                  <div class="checkbox-container" style="display: flex; align-items: center;">
                    <input type="checkbox" [(ngModel)]="emailOffers" id="emailOffers" style="margin-right: 10px;" (change)="updateSaveButtonState()">
                    <label for="emailOffers">
                      <span style="color: #333; font-size: 16px;">
                        {{ 'LoginModal.PromotionalInfoDescription' | translate }}
                      </span>
                    </label>
                  </div>
                  <button class="custom-button" (click)="updateEmailOffers($event)" style="width: 200px;"
                  [disabled]="!isSaveButtonEnabled"
                  [ngStyle]="{'background-color': isSaveButtonEnabled ? '#00566A' : 'lightgray', 'color': isSaveButtonEnabled ? 'white' : 'gray'}">
                  {{ 'LoginModal.SaveButton' | translate }}
                </button>
                

                    <div *ngIf="successPopupVisible" class="success-popup">
                    <div class="popup-content">
                      <h3>{{ 'LoginModal.SuccessUpdate' | translate }}</h3>
                    </div>
                  </div>
                  <div *ngIf="failurePopupVisible" class="failure-popup">
                    <div class="popup-content">
                      <h3>{{ 'LoginModal.FailureUpdate' | translate }}</h3>
                      <p>{{ serviceErrorDesc }}</p> <!-- Display additional error information if available -->
                      <button (click)="closeFailurePopup()">{{ 'LoginModal.CloseFailurePopup' | translate }}</button>
                    </div>
                  </div>
                  
                </div>
             <!-- Failure Popup -->
<!-- <div *ngIf="failurePopupVisible" class="failure-popup">
  <p>{{ 'LoginModal.PasswordValidationFailed' | translate }}</p>
  <button (click)="closeFailurePopup()">OK</button>
</div> -->
<div *ngIf="showPasswordConfirmation" class="password-confirmation-container" style="display: flex; justify-content: center; align-items: center; height: 100vh;">
  <div class="password-confirmation-modal" style="background-color: white; padding: 20px; border: 1px solid white; position: relative; text-align: center;">
    <button (click)="cancelPasswordConfirmation()" style="position: absolute; top: 10px; right: 10px; background: transparent; border: none; color: black; font-size: 20px; cursor: pointer;">X</button>
    <h2 style="color: Black;">{{ 'LoginModal.PasswordConfirmationTitle' | translate }}</h2>
    <br>
    <form #passwordForm="ngForm">
        <mat-form-field class="example-full-width" appearance="outline" style="width: 100%;">
          <mat-label for="confirmPassword" style="color: black;">{{ 'LoginModal.PasswordConfirmationLabel' | translate }}</mat-label>
          <input matInput type="password" id="confirmPassword" name="confirmPassword" [(ngModel)]="confirmPassword" required>
        </mat-form-field>
      <button class="change-button" (click)="changeEmail(confirmPassword)" style="background-color: #00566A; width: 200px; margin-top: 20px;">{{ 'LoginModal.PasswordConfirmationButton' | translate }}</button>
  
      <!-- Display the error message when password validation fails -->
      <div *ngIf="passwordValidationFailed" style="color: red; margin-top: 10px;">
        {{ 'LoginModal.PasswordValidationFailed' | translate }}
      </div>
    </form>
  </div>  
</div>




               <!-- Success Popup -->
              <!-- <div *ngIf="successPopupVisible" class="success-popup">
              <p>Success: Email update was successful.</p>
            <button (click)="closeSuccessPopup()">OK</button>
            </div> -->
            </div>
          </form>
          </div>
          <div *ngIf="SelectEmail && contentChanged">
              <div class="mbfs-contact-us-page-inner" style="padding-top: 21px; padding-bottom: 15px; padding-left: 21px;">
                <div *ngIf="SelectEmail">
                  <form [formGroup]="manageEmailForm" (ngSubmit)="updateEmailPreferences($event)"  *ngIf="openLoginModal">
                    <div class="row">
                      <div class="col-md-6">
                        <h1>{{ 'LoginModal.ChangeEmail' | translate }}</h1>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6"> 
                        <b> {{ 'LoginModal.EmailNewUpdate' | translate }}</b>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-6">
                          <b style="padding: 15px;" for="email">{{ 'LoginModal.Email' | translate }} </b><br>
                          <div class="col">
                            <input class="form-control" type="email" name="emailAddress" id="emailAddress"
                              formControlName="emailAddress" required validateonblur value="" autocomplete="off">
                            <li style="color:black; padding: 15px;"
                              *ngIf="this.manageEmailForm.get('emailAddress') && this.manageEmailForm.get('emailAddress').errors && this.manageEmailForm.get('emailAddress').errors.pattern">
                              {{ 'LoginModal.NotValid' | translate }}</li>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <b style="padding: 15px;" for="email">{{ 'LoginModal.Re-EnterMail' | translate }}</b><br>
                          <div class="col">
                            <input class="form-control" type="email" name="reEnterEmailAddress" id="reEnterEmailAddress"
                              formControlName="reEnterEmailAddress" required validateonblur value="" autocomplete="off">
                                <li style="color:black; padding: 15px;" *ngIf="!reentercheck">{{ 'LoginModal.EmailNotMatch' | translate }}</li>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 text-center">
                       <!--Spinner on Login Load-->
                      <div *ngIf="(!this.dataLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                        <div class="mbfs-loading-spinner-overlay"></div>
                        <div class="mbfs-loading-spinner"> </div>
                    </div>
                        <div *ngIf="agentview==='true'">
                          <button type="submit" name="save preferences" [disabled]="true">{{ 'LoginModal.Save' | translate }}</button>
                        </div>
                        <div *ngIf="agentview!='true'">
                          <button type="submit" name="save preferences" [disabled]="!tableLoaded || (this.manageEmailForm.get('reEnterEmailAddress').errors || this.disabledFlag)" class="mbfs-button">{{ 'LoginModal.Save' | translate }}</button>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 text-center">
                        <span style="color:#00566A;" *ngIf="confirmMailReset2"> {{ 'LoginModal.EmailUpdateSuccess' | translate }}</span>
                      </div>
                    </div>
                    <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                      <!--Spinner on Login Load-->
                      <div class="demo-container">
                        <span>{{ 'Invoice.Loading' | translate }}</span>
                        <div class="progress-bar">
                          <div class="progress-bar-value"></div>
                        </div>
                      </div>
                      <br>
                    </div>
                  </form>
      
                </div>
          </div>
          </div>
    
          <div *ngIf="SelectChangePassword">

            <form [formGroup]="manageProfileForm" (ngSubmit)="updateAndSaveNewPassword($event)" *ngIf="openLoginModal">
              <div class="tile" style="margin: 10px; padding: 10px; background-color: white;">
                <h1 class="mbfs-modal-header">{{ 'LoginModal.ChangePassword' | translate }}</h1>
                <div class="mbfs-bank-profile-create-inner">
                  <p class="mbfs-passwordreset-title">{{ 'LoginModal.SelectPassword' | translate }}</p>
                  <div class="testtext" style="margin-left: 22px;">
                    <li style="color:black;"
                      *ngIf="this.manageProfileForm.get('password') && this.manageProfileForm.get('password').errors && this.manageProfileForm.get('password').errors.pattern">
                      {{ 'LoginModal.SpecialCharacter' | translate }}</li>
                    <li style="color:black;" *ngIf="!this.hasLowerCase">{{ 'LoginModal.MPLowerCase' | translate }}</li>
                    <li style="color:black;" *ngIf="!this.hasUpperCase">{{ 'LoginModal.MPUpperCase' | translate }}</li>
                    <li style="color:black;" *ngIf="!this.hasNumeric">{{ 'LoginModal.MPNumeric' | translate }}</li>
                    <li style="color:black;" *ngIf="!this.hasMinimum">{{ 'LoginModal.MPMinimum' | translate }}</li>
                    <li style="color:black;" *ngIf="!this.hasMaximum">{{ 'LoginModal.MPMaximum' | translate }}</li>
                    <li style="color:black;" *ngIf="!this.userIDcheck">{{ 'LoginModal.MPUserIdCheck' | translate }}</li>

                  </div><br>
                  <div class="mbfs-text-form" [ngClass]="formValidationClasses">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-6">
                          <label for="password">{{ 'LoginModal.OldPassword' | translate }}</label>


                          <div class="col" style="display:flex;">
                            <input type="password" name="currentPassword" id="currentPassword" #password1
                              class="form-control" formControlName="currentPassword" required validateonblur value=""
                              onPaste="return false" autocomplete="off">
                              <div class="input-group-append" style="max-height: 38px;" (click)="changeType(password1, hide)">
                                <span class="input-group-text" ><i [ngClass]="hide ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></span>
                              </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label for="password">{{ 'LoginModal.Password1' | translate }}</label>


                          <div class="col">
                            <div style="display:flex;">
                            <input class="form-control" type="password" name="password" id="password" #password2
                              formControlName="password" required validateonblur value="" onPaste="return false"
                              autocomplete="off" >
                              <div class="input-group-append" style="max-height: 38px;" (click)="changeType(password2, hide1)">
                                <span class="input-group-text" ><i [ngClass]="hide1 ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></span>
                              </div></div>
                              <li style="color:black;"
                              *ngIf="this.manageProfileForm.get('password') && this.manageProfileForm.get('password').errors && this.manageProfileForm.get('password').errors.pattern">
                              {{ 'LoginModal.NotValidPassword' | translate }}</li>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <label for="password">{{ 'LoginModal.Password2' | translate }}</label>


                          <div class="col" >
                            <div style="display:flex;">
                            <input type="password" name="reTypePassword" id="reTypePassword" #password3
                              class="form-control" formControlName="reTypePassword" required validateonblur value=""
                              onPaste="return false" autocomplete="off">
                              <div class="input-group-append" style="max-height: 38px;" (click)="changeType(password3, hide2)">
                                <span class="input-group-text" ><i [ngClass]="hide2 ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></span>
                              </div></div>
                              <li style="color:black;" *ngIf="!reentercheck">{{ 'LoginModal.PasswordNotMatch' | translate }}</li>

                          </div>
                        </div>


                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12 text-center">
                    <!--Spinner on Login Load-->
                      <div *ngIf="(!this.dataLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                        <div class="mbfs-loading-spinner-overlay"></div>
                        <div class="mbfs-loading-spinner"> </div>
                    </div>
                    <div *ngIf="agentview==='true'">
                      <button type="submit"  [disabled]="true" class="mbfs-button">{{ 'LoginModal.SavePassword' | translate }}</button>
                    </div>
                    <div *ngIf="agentview!='true'">
                      <button type="submit"  [disabled]="(this.manageProfileForm.get('reTypePassword').errors || this.disabledFlag)" class="mbfs-button">{{ 'LoginModal.SavePassword' | translate }}</button>
                    </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <span style="color:black;" *ngIf="this.serviceErrorOccurred">{{'LoginModal.InvalidCurrentPassword' | translate }}</span>
                    </div>
                    <div class="col-md-12 text-center">
                      <span style="color:#00566A;" *ngIf="this.currentPasswordDBCheckFlag">{{
                        'LoginModal.SuccessPassword' | translate }}</span>
                    </div>
                   
                  </div>
                </div>
              </div>

            </form>
          </div>
          <div *ngIf="SelectAutopay">
            <div class="dtf-autoPay"></div>
          </div>
          <div class="tile" *ngIf="SelecteBill" style="margin: 10px;  padding: 10px; background-color: white;">
            <form #form="ngForm"  *ngIf="!this.bodyLoaded">
              <div class="row">
                <div class="col-md-6">
                  <h1>{{ 'LoginModal.MPeBillEnroll' | translate }}</h1>
                </div>
              </div>
             
 <div *ngIf="SelectEnrollForm">
                <form #form="ngForm" (ngSubmit)=" saveEnrollOrCancelOptionToALFA('ENROLL')" *ngIf="!this.bodyLoaded">
                  <div class="row">
                    <div class="col">
                      <p>{{ 'LoginModal.MPebillEnroll2' | translate }}</p>

                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span style="color:#00566A;">{{ 'LoginModal.MPeBill1' | translate }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span>{{ 'LoginModal.MPeBill2' | translate }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span>{{ 'LoginModal.MPeBill3' | translate }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <b>{{ 'LoginModal.MPeBill9' | translate }}</b>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-center">
                    <!--Spinner on Login Load-->
                    <div *ngIf="LessAccounts">
                    <div *ngIf="(!this.dataLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                      <div class="mbfs-loading-spinner-overlay"></div>
                      <div class="mbfs-loading-spinner"> </div>
                  </div>
                    </div>
                  <div *ngIf="agentview==='true'">
                    <button class="w-75" type="submit" [disabled]="true" class="mbfs-button" style="margin-top:15px;">{{ 'LoginModal.Enroll' | translate }}</button>
                  </div>
                  <div *ngIf="agentview!='true'">
                    <button class="w-75" type="submit" [disabled]="this.disabledFlag" class="mbfs-button" style="margin-top:15px;">{{ 'LoginModal.Enroll' | translate }}</button>
                  </div>

                  </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <span style="color:#00566A;" *ngIf="this.confirmEnroll">{{ 'LoginModal.MPeBill4' | translate }} </span>
                      <span style="color:#00566A; font-weight: bold;" *ngIf="!this.confirmTerminate && EmailSentCopy">{{ 'LoginModal.MoreAccountsBold' | translate }}</span><br>
                      <span style="color:#00566A;" *ngIf="!this.confirmTerminate && EmailSentCopy">{{ 'LoginModal.MoreAccounts' | translate }}</span>
                    </div>
                  </div>
                 </form>
              </div>

              <div *ngIf="SelectTerminateForm">
                <form #form="ngForm" (ngSubmit)=" saveEnrollOrCancelOptionToALFA('TERMINATE')" *ngIf="!this.bodyLoaded ">
                  <div class="row">
                    <div class="col">
                      <span>{{ 'LoginModal.MPeBill6' | translate }}</span>

                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-center">
                  <!--Spinner on Login Load-->
                  <div *ngIf="LessAccounts">
                  <div *ngIf="(!this.dataLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                    <div class="mbfs-loading-spinner-overlay"></div>
                    <div class="mbfs-loading-spinner"> </div>
                  </div>
                  </div>
                  <div *ngIf="agentview==='true'">
                  <button class="w-75" type="submit" [disabled]="true" class="mbfs-button">{{ 'LoginModal.Terminate' | translate }}
                 </button> </div>
                 <div *ngIf="agentview!='true'">
                  <button class="w-75" type="submit" [disabled]="this.disabledFlag" class="mbfs-button">{{ 'LoginModal.Terminate' | translate }}
                  </button>  
                </div>
                      
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <span style="color:#00566A;" *ngIf="this.confirmTerminate">{{ 'LoginModal.MPeBill7' | translate }} </span>
                      <span style="color:#00566A; font-weight: bold;" *ngIf="!this.confirmTerminate && EmailSentCopyTerminate">{{ 'LoginModal.MoreAccountsBold' | translate }}</span><br>
                      <span style="color:#00566A;" *ngIf="!this.confirmTerminate && EmailSentCopyTerminate">{{ 'LoginModal.MoreAccountsterminate' | translate }}</span>
                    </div>
                  </div>
                </form>
              </div>

            </form>

          </div>
          <div class="dtf-accountdetails && tile" *ngIf="SelectChangeAddress" style="margin: 10px; padding: 10px; background-color: white;">
            <form #form="ngForm" (ngSubmit)="changeOfAddress($event)" *ngIf="openLoginModal">
              <div class="row">
                <div class="col-md-6">
                  <h1>{{ 'LoginModal.ChangeofAddress' | translate }}</h1>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-md-6">
                    <b for="streetAddress">{{ 'ChangeAddress.StreetAddress' | translate }}*</b><br>
                    <div class="col">
                      <input class="form-control" type="text" name="streetAddress" id="streetAddress" [(ngModel)]="streetAddress"  required validateonblur value="" autocomplete="off">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <b for="city">{{ 'ChangeAddress.City' | translate }}*</b><br>
                    <div class="col">
                      <input class="form-control" type="text" name="city" id="city" [(ngModel)]="city"  required validateonblur value="" autocomplete="off">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <b for="state">{{ 'ChangeAddress.State' | translate }}*</b><br>
                    <div class="col">
                      <mat-form-field appearance="outline">
                        <mat-select style="color: black;"  *ngIf="isCanadaPortal" name="state" [(ngModel)]="state" placeholder="{{ 'ChangeAddress.SelectState' | translate }}">
                          <mat-option *ngFor="let request of stateCanadaLabelValues" [value]="request.value">
                            {{request.value}}
                          </mat-option>
                        </mat-select>

                        <mat-select *ngIf="!isCanadaPortal" name="state" [(ngModel)]="state" placeholder="{{ 'ChangeAddress.SelectState' | translate }}">
                          <mat-option *ngFor="let request of stateLabelValues" [value]="request.value">
                            {{request.value}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <b for="zipCode">{{ 'ChangeAddress.ZipCode' | translate }}*</b><br>
                    <div class="col">
                      <input class="form-control" type="text" name="zipCode" id="zipCode" [(ngModel)]="zipCode" required validateonblur value="" autocomplete="off">
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                <!--Spinner on Login Load-->
                <div class="demo-container">
                  <span>{{ 'Invoice.Loading' | translate }}</span>
                  <div class="progress-bar">
                    <div class="progress-bar-value"></div>
                  </div>
                </div>
                <br>
              </div>
              <div class="row">
                <div class="col">
                  <p>{{ 'LoginHeader.ChangeofAddressCopy' | translate }}</p>
                </div>
              </div>
              <div class="accountflex">
                <h1 class="mercedes-me-login__column-headline2"> </h1>
                <mat-form-field class="example-form-field" appearance="outline">
                  <mat-label>{{ 'AccountDetails.Search' | translate }}</mat-label>
                  <input matInput  (keyup)="applyFilter($event)" placeholder="Account Number or Status" #input type="text" [(ngModel)]="value">
                  <img matSuffix class="example-form-img" src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                </mat-form-field>
              </div>
              <mat-table [dataSource]="dataSource" multiTemplateDataRows  class="mat-elevation-z8" matSort>
          <!--US/EN Table loading-->
            <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initColumns; last as isLast; first as isFirst;">
              <div *ngIf="isFirst"> 
                <mat-checkbox  [ngClass]="{'white-border': !isChecked}" (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"  >
            </mat-checkbox></div>
              <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef style="justify-content: center;">
                <div *ngIf="isFirst"> 
                  <mat-checkbox [ngClass]="{'white-border': !isChecked}" (change)="$event ? masterToggle() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()"  >
              </mat-checkbox></div>
                <div *ngIf="!isFrench"> {{column.display}}</div>
                <div *ngIf="isFrench"> {{column.displayFR}}</div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="justify-content: center;">
                <div *ngIf="isFirst"   > <mat-checkbox (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(element) : null"
                  [checked]="selection.isSelected(element)" >
              </mat-checkbox></div>
                <span class="mobile-label">
                  <div *ngIf="!isFrench"> {{column.display}} :</div>
                  <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                </span>
                <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                  {{element[column.name] | currency:'USD':true:'1.2-2'}}
                </div>
                <div *ngIf="column.dispFormat=='contract'"> <!--Formats Contract String Columns-->
                  {{element[column.name]}}
                </div>
                <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
                  {{element[column.name]}}
                </div>
                <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
                  {{element[column.name] | date:'MM/dd/yyyy'}}
                </div>
              </mat-cell>
            </ng-container>
    
            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="accountDetailsRes">
            <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
              [attr.colspan]="displayedColumns.length">
            </mat-cell>
          </ng-container>
    
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let element; columns: displayedColumns;"
              class="example-element-row"
              [class.example-expanded-row]="accountDetailsRes === element"
              (click)="accountDetailsRes = accountDetailsRes === element ? null : element">
          </mat-row>
          <mat-row *matRowDef="let row; columns: ['accountDetailsRes']" class="example-detail-row"></mat-row>
    
          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data</td>
            <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée</td>
          </tr>
    
              </mat-table>
              <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
              <button  type="submit" [disabled]="this.disabledFlag" class="mbfs-button">{{ 'LoginModal.Submit' | translate }}</button>
            </form>

          </div>


          
        </div>

      </div>
    </div>
  </div>



</div>